import { render } from "./SelectedTargetList.vue?vue&type=template&id=30584161&scoped=true"
import script from "./SelectedTargetList.vue?vue&type=script&lang=js"
export * from "./SelectedTargetList.vue?vue&type=script&lang=js"

import "./SelectedTargetList.vue?vue&type=style&index=0&id=30584161&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SelectedTargetList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30584161"]])

export default __exports__